import TaskScriptModal from './TaskScriptModal';

export { TaskScriptModal };

export default {
	TaskScriptModal
};
